import React from 'react'
import { useBranding } from '../contexts/BrandingContext'

const LogoFull = ({ className = "" }) => {
  const { logoUrl } = useBranding()

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {logoUrl ? (
        <img
          src={logoUrl}
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
          alt="Villa Experience Logo"
          className="h-10 w-auto object-contain"
        />
      ) : (
        <div className="w-10 h-10 rounded-lg bg-white border border-gold flex items-center justify-center text-xs font-semibold text-[#cfa190]">
          VE
        </div>
      )}
      <div className="flex-1">
        <div className="flex flex-col">
          <span className="text-[#1e2a2e] font-display text-xl font-bold tracking-tight">
            VILLA EXPERIENCE
          </span>
          <span className="text-xs text-grayAccent uppercase tracking-wider">
            Owner & Villa Management
          </span>
        </div>
      </div>
    </div>
  )
}

export default LogoFull

